import React from 'react'
import { Grid, Segment } from 'semantic-ui-react'

import constants from 'config/constants'

import StatusIcon from './StatusIcon'

import './styles.css'

interface AuthenticationShellProps {
  children?: React.ReactNode
  headerText?: React.ReactNode
  subHeaderText?: React.ReactNode
  icon?: React.ReactNode
}

function AuthenticationShell({
  children,
  headerText,
  subHeaderText,
  icon,
}: AuthenticationShellProps) {
  return (
    <Grid centered verticalAlign="middle" className="authentication-shell">
      <Grid.Column mobile={16} tablet={12} computer={8}>
        <Segment className="padding">
          <div className="authentication-shell__header">
            <div className="authentication-shell__media">
              {icon ?? (
                <img
                  alt="SimplesatLogo"
                  src={constants.simplesatLogoGreenUrl}
                  className="authentication-shell-logo"
                />
              )}
            </div>
            {(headerText || subHeaderText) && (
              <div className="authentication-shell__text">
                {headerText && <h1 className="authentication-shell__title">{headerText}</h1>}
                {subHeaderText && <p className="authentication-shell__subtitle">{subHeaderText}</p>}
              </div>
            )}
          </div>
          {children}
        </Segment>
      </Grid.Column>
    </Grid>
  )
}

AuthenticationShell.StatusIcon = StatusIcon

export default AuthenticationShell



// WEBPACK FOOTER //
// ./src/shared/components/AuthenticationShell/index.tsx